'use strict';

var defaults = require('../../defaults/Defaults');
var moment = require('moment-timezone');
require('./KayleeService');
require('./RoomService');

angular.module('inara').factory('ClockService', ClockService);

ClockService.$inject =
    ['$rootScope', '$interval', 'KayleeService', 'RoomService'];

function ClockService($rootScope, $interval, KayleeService, RoomService) {
    var clockInterval = null;
    var formattedTime = null;
    var room = null;
    var site = null;
    var timeZone = null;
    var timeFormat = null;

    useDefaultFormat();
    formatTime();
    startClock();
    RoomService.onOnlineChanged(onRoomOnlineChanged);
    $rootScope.$on('$destroy', stopClock);

    return {
        getFormattedTime: getFormattedTime
    };

    function formatTime() {
        var formatted = moment().tz(timeZone).format(timeFormat);
        if (formattedTime !== formatted) formattedTime = formatted;
    }

    function getFormattedTime() {
        return formattedTime;
    }

    function onRoomOnlineChanged(isOnline) {
        if (isOnline) {
            room = RoomService.getRoom();
            site = KayleeService.getSite(room.siteId);
            site.$onChange(onSiteChanged);
        } else {
            if (site !== null) site.$offChange(onSiteChanged);
            room = null;
            site = null;
            useDefaultFormat();
        }
    }

    function onSiteChanged() {
        if (!RoomService.online() || room === null || site === null) return;
        timeZone = site.settings.timeZone;
        timeFormat = site.settings.timeFormat;
    }

    function startClock() {
        stopClock();
        clockInterval = $interval(formatTime, 1000);
    }

    function stopClock() {
        if (clockInterval !== null) {
            $interval.cancel(clockInterval);
            clockInterval = null;
        }
    }

    function useDefaultFormat() {
        timeZone = defaults.inara.timeZone;
        timeFormat = defaults.inara.timeFormat;        
    }
}

module.exports = ClockService;
